export function AnalyticsTab() {
  return <div style={{ padding: "28px 32px" }}><h1>Analytics</h1><p>Catalog analytics and insights.</p></div>;
}
